<template>
	<div class="benefit-page">
		<section class="benefit-general-info">
			<h2 class="level-one-heading mb-5">Mina medlemsförmåner</h2>
			<hr class="_strong">
			<p>
				Som medlem på Webhallen får du flera förmåner. Med vårt lojalitetsprogram får du poäng <b>(XP)</b> varje gång du handlar. Med högre <b>XP</b> får du fler fördelar, som t.ex. medlemserbjudanden med lägre priser på utvalda varor och fraktrabatter.
			</p>
			<video
				v-if="videoThumbnail"
				ref="memberVideo"
				class="member-video"
				:poster="videoThumbnail"
				controls
			/>
			<router-link
				class="read-more"
				to="/info/6-Medlem"
			>Läs mer om vårt medlemssystem här.</router-link>
		</section>
		<div class="column">
			<section>
				<h3>Upplåsta förmåner</h3>
				<benefit-row
					v-for="row in currentLevelBenefits"
					:key="row.description"
					:benefit="row"
				/>
			</section>
			<section>
				<h3>Aktiva perks</h3>
				<p>Perks är tillfälliga bonusar som tilldelas ditt medlemskonto. Nya perks kan du få som supply drops eller när du går upp i level.</p>
				<p v-if="! user.userPerks.length">Du har för närvarande inga perks aktiverade.</p>
				<benefit-row
					v-for="row in user.userPerks"
					v-else
					:key="row.description"
					:benefit="row.perk"
					:validTo="row.validTo"
					:scaleIcon="true"
				/>
			</section>
			<section v-if="nextBenefits">
				<h3>Nästa level</h3>
				<div>
					<p>
						Varje gång du går upp i level låser du upp nya förmåner, och får dessutom en ny level up-låda bland dina <router-link :to="$router.route(supplyLink)">Supply drops</router-link>.
					</p>
					<div class="opacity">
						<benefit-row
							v-for="row in nextBenefits"
							:key="row.index"
							:benefit="row"
						/>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import Hls from 'hls.js';

export default {
	props: {
		user: {
			type: Object,
		},
	},
	data () {
		return {
			currentLevelBenefits: [],
			nextBenefits: [],
			videoThumbnail: null,
			videoSrc: null,
			totalDuration: 0,
		};
	},
	computed: {
		supplyLink () {
			const supplyRoute = {};
			const id = this.$route.params.id;
			const name = this.$route.params.name;
			const params = {
				id,
				name,
			};

			supplyRoute.name = 'member.supply-drop';
			supplyRoute.params = params;

			return supplyRoute;
		},
	},
	mounted () {
		this.getBenefits();
		this.getMemberVideo();
	},
	methods: {
		getBenefits () {
			waja.get('user/me/benefits')
				.on('success', res => {
					this.currentLevelBenefits = res.data[0];
					this.nextBenefits = res.data[1];
				}).go();
		},
		getMemberVideo () {
			waja.get('user/me/video')
				.on('success', res => {
					if (res.data?.videoSrc) {
						this.videoThumbnail = res.data.videoThumbnail;
						this.videoSrc = res.data.videoSrc;
						this.addVideoSource();
					}
				}).go();
		},
		addVideoSource () {
			if (this.$refs.memberVideo) {
				const hls = new Hls();
				const stream = this.videoSrc ;
				const video = this.$refs.memberVideo;
				hls.loadSource(stream);
				hls.attachMedia(video);

				hls.once(Hls.Events.LEVEL_LOADED, function (event, data) {
					this.totalDuration = data.details.totalduration;
				});

				hls.on(Hls.Events.FRAG_CHANGED, function (event, data) {
					if (data.frag.endPTS >= this.totalDuration) {
						waja.post('achievement/attention-span').go();
					}
				});
			} else {
				setTimeout(() => {
					this.addVideoSource();
				}, 1000);
			}
		},
	},
};
</script>
